<script>
/**
 * 内页顶部 hero + 面包屑（自 vancheen-b2b 的 PageHero.vue 移植为 Vue 2 版本）
 * 面包屑用 Element UI 的 el-breadcrumb，外观由 nh-theme.css 还原。
 */
export default {
  name: 'NhPageHero',
  props: {
    crumbs: { type: Array, default: () => [] },
    /** 标题上方的胶囊标签，例如工厂页的 PARTNER FACTORY TOUR */
    eyebrow: { type: String, default: '' },
    title: { type: String, default: '' },
    desc: { type: String, default: '' }
  }
}
</script>

<template>
  <section class="page-hero">
    <div class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="crumb in crumbs" :key="crumb.label" :to="crumb.to">
          {{ crumb.label }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <span v-if="eyebrow" class="eyebrow">{{ eyebrow }}</span>
      <h1>{{ title }}</h1>
      <p>{{ desc }}</p>
    </div>
  </section>
</template>
